export default __webpack_public_path__ + "static/reporting.url-f533cdef0cf0e285bf6eb67aedc9f0bd.svg";